export const PROPS_SAMPLE_ATTRIBUTE_NAME = "sampleAttributeName";
export const PROPS_SAMPLE_ATTRIBUTE_GUID = "sampleAttributeGuid";
export const PROPS_SAMPLE_ATTRIBUTE_DESCRIPTION = "sampleAttributeDescription";
export const PROPS_SAMPLE_ATTRIBUTE_TYPE = "sampleAttributeSampleTypes";
export const PROPS_SYSTEM_ATTRIBUTE_NAME = "systemAttributeName";
export const PROPS_TEST_TYPE = "testType";
export const PROPS_SYSTEM_UNIT = "systemUnit";
